import { Ajax } from "@bamboohr/utils";
import { AxiosPromise } from "axios";

export const enableQrLogin = (): AxiosPromise => {
	try {
		return Ajax.post('/auth/mobile_qr');
	} catch (error) {
		throw new Error('Failed to enable QR login.');
	}
}